/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { useState } from 'react';
import { Policy, PolicyChallenge, PolicyMilestone, PolicyGameEffect } from '../types/policy';

export function usePolicyState() {
  const [policies, setPolicies] = useState<Policy[]>([]);
  const [policyChallenges, setPolicyChallenges] = useState<PolicyChallenge[]>([]);
  const [policyMilestones, setPolicyMilestones] = useState<PolicyMilestone[]>([]);
  const [activePolicy, setActivePolicy] = useState<Policy | null>(null);
  const [policyEffects, setPolicyEffects] = useState<PolicyGameEffect[]>([]);

  return {
    policies,
    setPolicies,
    policyChallenges,
    setPolicyChallenges,
    policyMilestones,
    setPolicyMilestones,
    activePolicy,
    setActivePolicy,
    policyEffects,
    setPolicyEffects,
  };
}